/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dayjs } from "dayjs";
import React from "react";
import { useCameraApi } from "~/api/GeneratedApi";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";

type CameraId = number | null | undefined;

export type RecordedDatesType = {
  cameraId: CameraId;
  dateMin?: Dayjs | undefined;
  dateMax?: Dayjs | undefined;
};

export type RecordedDatesQueryKeyType = {
  cameraId: CameraId;
  dateMin?: string | undefined;
  dateMax?: string | undefined;
};

export type RecordedTimesType = {
  cameraId: number | undefined;
  date?: Dayjs | undefined | null;
};

export type RecordedTimesQueryKeyType = {
  cameraId: number | undefined;
  date?: string | undefined;
};

export type RecordedHlsStreamType = {
  cameraId: CameraId;
  dateTime?: Date | undefined;
  duration?: number | undefined;
  enabled?: boolean;
};
export type RecordedHlsStreamQueryKeyType = {
  cameraId: CameraId;
  dateTime?: string | undefined;
  duration: string;
};
// function dateToISOButLocal(date: Date) {
//   return date.toLocaleString("sv").replace(" ", "T");
// }
// const twoMonthsAgo = new Date(new Date().setMonth(new Date().getMonth() - 2));
// const twoDaysAgo = new Date(Date.now() - 2 * 24 * 60 * 60 * 1000);
// const daysAhead = (days: number) =>
//   new Date(Date.now() + days * 24 * 60 * 60 * 1000);
// const daysAgo = (days: number) =>
//   new Date(Date.now() - days * 24 * 60 * 60 * 1000);

// const hoursAgo = (hours: number) =>
//   new Date(Date.now() - hours * 60 * 60 * 1000);

export const useRecordedDates = ({
  cameraId,
  dateMax,
  dateMin,
}: RecordedDatesType) => {
  const { recordedDates } = useCameraApi();

  const queryEnabled = React.useMemo(
    () => !!cameraId && dateMin !== undefined && dateMax !== undefined,
    [cameraId, dateMax, dateMin],
  );
  // console.log(dateMin, dateMax);
  // console.log(
  //   dateMin.format("YYYY-MM-DDTHH:mm:ssZ"),
  //   dateMax?.format("YYYY-MM-DDTHH:mm:ssZ"),
  // );
  // console.log(dateMin.format("Z"));
  // console.log(dayjs().endOf("month"));

  const offsetHours = (dateMax?.utcOffset() ?? 0) / 60;

  const offset = offsetHours > 0 ? offsetHours : `-${offsetHours}`;

  const dateMaxUtc = dateMax?.format("YYYY-MM-DDTHH:mm:ssZ");
  const dateMinUtc = dateMin?.format("YYYY-MM-DDTHH:mm:ssZ");
  const { data: availableDates, isLoading: datesLoading } = useCustomQuery(
    {
      key: "recorded-dates",
      cameraId: cameraId as number,
      dateMax: dateMaxUtc,
      dateMin: dateMinUtc,
    },
    () => {
      // return new Promise<Date[]>((res) => {
      //   setTimeout(
      //     () =>
      //       res([
      //         new Date(),
      //         daysAgo(1),
      //         daysAgo(3),
      //         daysAgo(7),
      //         daysAhead(1),
      //         daysAhead(3),
      //         daysAhead(7),
      //       ]),
      //     3000,
      //   );
      // });
      return recordedDates(cameraId as number, {
        dateMax: dateMax?.toDate() as Date,
        dateMin: dateMin?.toDate() as Date,
        utcOffsetHours: Number(offset),
      });
    },
    { enabled: queryEnabled },
  );
  return { availableDates, datesLoading };
};
// export interface CameraTimesItemDto {
//   startInclusive: Date;
//   endExclusive: Date;
// }
export const useRecordedTimes = ({ cameraId, date }: RecordedTimesType) => {
  const { recordedTimes } = useCameraApi();

  const queryEnabled = React.useMemo(
    () => !!cameraId && !!date,
    [cameraId, date],
  );
  const { data: availableTimes, isLoading: availableTimesLoading } =
    useCustomQuery(
      {
        key: "recorded-times",
        cameraId: cameraId as number,
        date: date?.toString(),
      },
      () => {
        // console.log(date?.startOf("day"));
        // const offsetHours = date?.utcOffset() / 60;
        // const testDate = dayjs("2023-01-01T00:00:00-05:00");
        // console.log(testDate);
        // console.log(-testDate.utcOffset());
        // const offset = offsetHours > 0 ? offsetHours : `-${offsetHours}`;
        // console.log(date?.utcOffset() % 60);

        // return new Promise<CameraTimesItemDto[]>((res) => {
        //   setTimeout(
        //     () =>
        //       res([
        //         {
        //           startInclusive: "2023-04-03T21:00:00Z",
        //           endExclusive: "2023-04-04T21:00:00Z",
        //         },
        //         { startInclusive: hoursAgo(2), endExclusive: new Date() },
        //         { startInclusive: hoursAgo(4), endExclusive: hoursAgo(3) },
        //       ]),
        //     1500,
        //   );
        // });
        return recordedTimes(cameraId as number, {
          date: date?.toDate(),
        });
      },
      { enabled: queryEnabled },
    );

  return { availableTimes, availableTimesLoading };
};
export const useRecordedHlsStream = ({
  cameraId,
  duration,
  dateTime,
  enabled = true,
}: RecordedHlsStreamType) => {
  const { recordedHlsStream } = useCameraApi();

  const queryEnabled = React.useMemo(
    () => !!cameraId && !!duration && !!dateTime && enabled,
    [cameraId, dateTime, duration, enabled],
  );

  const { data: recordedStream, ...rest } = useCustomQuery(
    {
      key: "recorded-hls-stream",
      cameraId: cameraId as number,
      duration: duration?.toString() ?? "",
      dateTime: dateTime?.toString(),
    },
    () => {
      // console.log("fetch");
      // return Promise.resolve({
      //   results: [
      //     {
      //       id: 1,
      //       name: "string",
      //       description: "string",
      //       streamUrl:
      //         "rtsp://wowzaec2demo.streamlock.net/vod/mp4:BigBuckBunny_115k.mp4",
      //       aisModemDeviceId: "string",
      //       aisModemName: "string",
      //       vesselName: "string",
      //       record: false,
      //     },
      //   ],
      //   currentPage: 0,
      //   pageSize: 0,
      //   totalCount: 0,
      // });
      return recordedHlsStream(cameraId as number, {
        dateTime,
        durationSeconds: Math.round(duration as number),
      });
    },
    { enabled: queryEnabled },
  );

  return { recordedStream, ...rest };
};
